module.exports = __webpack_public_path__ + "img/sign-overly-top.8882aefa.png";